import React, { useState } from 'react';
import cardImage1 from './assets/beatport.png';
import cardImage2 from './assets/lynes.png';
import cardImage3 from './assets/runn.png';

const styles = {
  container: {
    marginTop:'1em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom:'10em'
  },
  carouselWrapper: {
    position: 'relative',
    width: '70%',
    maxWidth: '1160px'
  },
  cardsContainer: {
    position: 'relative',
    height: '42rem'
  },
  card: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: '1rem',
    borderRadius: '0.75rem',
    boxShadow: '0 0 20px rgba(0, 0, 0, 0.3)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    left: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundSize: 'cover',
    backgroundPosition: 'center -0.35em' // Changed to move image up by 1em
  },
  cardContent: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    zIndex: 1
  },
  cardTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: '#f3f4f6'
  },
  cardText: {
    color: '#d1d5db'
  },
  cardOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '0.75rem'
  }
};

const StackedCarousel = () => {
  const [activeKey, setActiveKey] = useState(0);
  
  const items = [
    {
      key: 0,
      image: cardImage3
    },
    {
      key: 1,
      image: cardImage1
    },
    {
      key: 2,
      image: cardImage2
    }
  ];

  const handleCardClick = (clickedKey) => {
    // Only handle clicks on the active card
    if (clickedKey === activeKey) {
      // Move to next card, wrapping around to 0 if at the end
      setActiveKey((current) => (current + 1) % items.length);
    } else {
      setActiveKey(clickedKey);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.carouselWrapper}>
        <div style={styles.cardsContainer}>
          {[...items].reverse().map((item) => {
            const cardStyle = {
              ...styles.card,
              backgroundImage: `url(${item.image})`,
              zIndex: item.key === activeKey ? 30 : item.key === (activeKey + 1) % items.length ? 20 : 10,
              transform: `translateX(-50%) ${
                item.key === activeKey ? 'translateY(6rem) scale(1)' :
                item.key === (activeKey + 1) % items.length ? 'translateY(3rem) scale(0.95)' :
                'translateY(0) scale(0.90)'
              }`,
            };
            
            return (
              <div
                key={item.key}
                onClick={() => handleCardClick(item.key)}
                style={cardStyle}
                className="border"
                onMouseOver={(e) => item.key !== activeKey && (e.currentTarget.style.filter = 'brightness(1.25)')}
                onMouseOut={(e) => item.key !== activeKey && (e.currentTarget.style.filter = 'brightness(1)')}
                onMouseDown={(e) => item.key !== activeKey && (e.currentTarget.style.filter = 'brightness(0.9)')}
                onMouseUp={(e) => item.key !== activeKey && (e.currentTarget.style.filter = 'brightness(1.25)')}
              >
                <div style={styles.cardOverlay} />
                <div style={styles.cardContent}>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StackedCarousel;
